(() => {
  if (!document.body.classList.contains('fct-product-page')) return;
  const sortedWidgets = new WeakSet();
  const refresh = () => {
    document.querySelectorAll('[data-fct-product-reviews] #judgeme_product_reviews').forEach(widget => {
      const select = widget.querySelector('.jdgm-sort-dropdown');
      if (!select || sortedWidgets.has(widget)) return;
      const newest = [...select.options].find(option => /most recent/i.test(option.textContent));
      if (!newest) return;
      sortedWidgets.add(widget);
      if (select.value !== newest.value) {
        select.value = newest.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

  };
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refresh(); });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  refresh();
})();

